export { default, getServerSideProps } from '@views/brands';
